(function ($) {
    $(document).ready(function () {
        // function resize() {
        //     var is_mobile = !ThemeJS.Media_Queries.is_at_least('lg');
        //     console.log(is_mobile);
        // }
        // $(window).on('breakpoint_changed', resize);
        // resize();

        $('.cards-slider').slick({
            arrows: false,
            slidesToShow: 3,
            adaptiveHeight: false,
            infinite: true,
            // adaptiveWidth: true,
            dots: false,
            centerMode: true,
            // customPaging: function (slider, i) {
            //     return $('<button>').html($('<span>').addClass('sr-only').text(i + 1));
            // },
            autoplay: true,
            autoplaySpeed: 4000,
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 2,
                        centerMode: true,
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1,
                        centerMode: true,
                    }
                }
            ]
        });
    });
})(jQuery);